import { render, staticRenderFns } from "./contractgoods.vue?vue&type=template&id=1008f23d&scoped=true&"
import script from "./contractgoods.vue?vue&type=script&lang=js&"
export * from "./contractgoods.vue?vue&type=script&lang=js&"
import style0 from "./contractgoods.vue?vue&type=style&index=0&id=1008f23d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008f23d",
  null
  
)

export default component.exports